export default __webpack_public_path__ + "static/media/icon_playstore_v3.adadc75d.png";